import React from "react";
import "./SubFooter.css";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../utils/motion";

const SubFooter = () => {
  return (
    <motion.section
      className="sub-footer"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className="sub-footer__glow" aria-hidden="true" />
      <div className="sub-footer-container">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ delay: 0.1 }}
        >
          Unleash Your Next Travel Story
        </motion.h3>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ delay: 0.2 }}
        >
          Get exclusive travel tips, insider guides, and handpicked deals delivered to inspire your next journey.
        </motion.p>
        <motion.a
          href="/contact"
          className="sub-footer-cta"
          whileHover={{ scale: 1.05, y: -3 }}
          whileTap={{ scale: 0.98 }}
        >
          Get Started →
        </motion.a>
      </div>
    </motion.section>
  );
};

export default SubFooter;
